<template>
  <div class="container">
    <div class="title" v-if="!editId">新建字典 <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span></div>
    <div class="title" v-else>
      <span >修改字典</span> <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span>
    </div>

    <div class="wrap">
      <el-row>
        <el-col :lg="16" :md="20" :sm="24" :xs="24">
          <el-form :model="sysDict" status-icon ref="form" label-width="auto" @submit.prevent :rules="rules">
            <el-form-item label="字典名称" prop="remark">
              <el-input v-model="sysDict.remark" placeholder="请填写字典名称"></el-input>
            </el-form-item>
            <el-form-item label="字典值" prop="name">
              <el-input v-model="sysDict.name" placeholder="请填写字典值"></el-input>
            </el-form-item>

            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm">保 存</el-button>
              <el-button @click="resetForm">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'

import sysDictModel from '@/model/sysDict'


export default {
  props: {
    editId: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    const form = ref(null)
    const loading = ref(false)
    const sysDict = reactive({ name: '', remark: ''})

    const listAssign = (a, b) => Object.keys(a).forEach(key => {
      a[key] = b[key] || a[key]
    })

    /**
     * 表单规则验证
     */
    const { rules } = getRules()

    onMounted(() => {
      if (props.editId) {
        getSysDict()
      }
    })

    const getSysDict = async () => {
      loading.value = true
      const res = await sysDictModel.getSysDict(props.editId)
      listAssign(sysDict, res)
      loading.value = false
    }

    // 重置表单
    const resetForm = () => {
      form.value.resetFields()
    }

    const submitForm = async formName => {
      form.value.validate(async valid => {
        if (valid) {
          let res = {}
          if (props.editId) {
            res = await sysDictModel.editSysDict(props.editId, sysDict)
            context.emit('editClose')
          } else {
            res = await sysDictModel.createSysDict(sysDict)
            resetForm(formName)
          }
          if (res.code < window.MAX_SUCCESS_CODE) {
            ElMessage.success(`${res.message}`)
          }
        } else {
          console.error('error submit!!')
          ElMessage.error('请将信息填写完整')
        }
      })
    }

    const back = () => {
      context.emit('editClose')
    }

    return {
      back,
      sysDict,
      form,
      rules,
      resetForm,
      submitForm,
    }
  },
}

/**
 * 表单验证规则
 */
function getRules() {
  /**
   * 验证回调函数
   */
  const checkInfo = (rule, value, callback) => {
    if (!value) {
      callback(new Error('信息不能为空'))
    }
    callback()
  }
  const rules = {
    remark: [{ validator: checkInfo, trigger: 'blur', required: true }],
    name: [{ validator: checkInfo, trigger: 'blur', required: true }],
  }
  return { rules }
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
